import * as React from "react";

import SupportHeader from "~/components/CustomerSupport/SupportHeader";
import styled from "~/styled";

const DashboardWrapper = styled.main`
  padding-bottom: 24px;
  border-radius: 3px;
  font-family: -apple-system, system-ui, BlinkMacSystemFont, "Segoe UI", Roboto,
    "Helvetica Neue", Arial, sans-serif;
  display: grid;

  grid-template-areas:
    "header"
    "overlap"
    "content";

  grid-template-rows: auto 50px auto auto;
  justify-items: center;
`;

const ContentWrapper = styled.div`
  display: grid;
  grid-area: overlap / content / content;
  max-width: 800px;
  margin-bottom: 24px;
`;

export default class SupportDashboardLayout extends React.Component {
  public render() {
    return (
      <DashboardWrapper>
        <SupportHeader />

        <ContentWrapper>{this.props.children}</ContentWrapper>
      </DashboardWrapper>
    );
  }
}



// WEBPACK FOOTER //
// ./src/layouts/SupportDashboardLayout.tsx